import React from "react";
import { EvtStatsCard as StatsCard } from "components/stats/display-card";
import { EvtStatsCardLoader } from "components/stats/loader";
import { DisplayAmount } from "components/display/amount";

// import { useOverdueStats } from "../hooks/useOverdueStats";
import { EvtHeader } from "components/header";

import { useDueStats } from "@/modules/reports/billables/status/hooks/useDateBasedStats";
import { useOverdueStats } from "@/modules/reports/billables/dashboard/hooks/useOverdueStats";
import {
  BILLING_HEALTH_INSIGHTS,
  DELAYED_AMOUNT,
  OVERDUE_AMOUNT,
} from "@/modules/reports/billables/dashboard/constant";

export function BillingHealthInsights({ dateRange }) {
  const { data: overdueStats, isLoading: isOverdueLoading } = useOverdueStats({ dateRange });
  const { data: dueStats, isLoading: isDueLoading } = useDueStats();

  const isLoading = isOverdueLoading || isDueLoading;

  if (isLoading) {
    return (
      <div>
        <EvtHeader title="Billing Health Insights" />
        <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-5 gap-4 px-6">
          {[...Array(5)].map((_, i) => (
            <EvtStatsCardLoader key={i} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <section className="mt-6">
      <EvtHeader
        title="Billing Health Insights"
        info={BILLING_HEALTH_INSIGHTS}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-5 gap-4 px-6">
        <StatsCard
          label="Delayed Amount"
          value={<DisplayAmount value={overdueStats?.delayedAmount || 0} />}
          info={DELAYED_AMOUNT}
        />
        <StatsCard
          label="Overdue Amount"
          value={<DisplayAmount value={overdueStats?.overdueAmount || 0} />}
          info={OVERDUE_AMOUNT}
        />
        <StatsCard
          label="Due Today"
          value={<DisplayAmount value={dueStats?.dueToday || 0} />}
        />
        <StatsCard
          label="Due (Next 15 Days)"
          value={<DisplayAmount value={dueStats?.dueNext15Days || 0} />}
        />
        <StatsCard
          label="Due (Next 30 Days)"
          value={<DisplayAmount value={dueStats?.dueNext30Days || 0} />}
        />
      </div>
    </section>
  );
}
